import { Fragment, ReactElement, useMemo } from 'react';
import { getBaseUrl } from '../../get-base-url';
import { useParams } from 'react-router-dom';
import CancellationNonResidentNotificationShared from 'shell/components/shared/research-notifications/research-death-non-resident/detail';
import { BreadcrumbItem } from 'shell/components/shared/breadcrumb';

interface CancellationNonResidentNotificationCivilStatusSharedProps {
  scope?: string;
  isOther?: boolean;
  items?: BreadcrumbItem[];
}

const CancellationNonResidentNotificationCivilStatusShared = ({
  scope,
  isOther,
  items,
}: CancellationNonResidentNotificationCivilStatusSharedProps): ReactElement => {
  const params = useParams();

  const idNotifica = params.idNotifica || '';
  const idCat = params.idCat || undefined;
  const idAnsc = useMemo(() => {
    return params.id || undefined;
  }, [params.id]);

  const baseUrl: string = useMemo(() => {
    return getBaseUrl(scope, idCat);
  }, [scope]);

  const goBackUrl: string = useMemo(() => {
    return `${baseUrl}/modifica/${idAnsc}/${idNotifica}`;
  }, [baseUrl, idAnsc, idNotifica]);

  const goBackUrlDetail: string = useMemo(() => {
    return `${getBaseUrl(scope, idCat)}/visualizza/${idAnsc}/${idNotifica}`;
  }, [scope, idAnsc, idCat]);

  return (
    <Fragment>
      <CancellationNonResidentNotificationShared
        goBackUrl={goBackUrl}
        goBackUrlDetail={goBackUrlDetail}
        items={items}
        isOther={isOther}
        editSipoUrl={`${goBackUrl}/morte/non-residenti/cancellazione/:idIntestatario/:idSchedaSoggettoANPR/persona-sipo`}
      />
    </Fragment>
  );
};

CancellationNonResidentNotificationCivilStatusShared.displayName =
  'Research Death Detail Notifications Page component';

export default CancellationNonResidentNotificationCivilStatusShared;
